module.exports = __webpack_public_path__ + "static/media/34.b2924950.jpg";